import { app } from '../../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.directory-groups.directory.add-new-group', {
        url: '/add-new-group',
        views: {
            '@company.user-directories': 'companyUserDirectoriesDirectoryGroupsDirectoryAddNewGroup'
        },
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/directory-groups/directory/add-new-group/add-new-group.state.js